import { ApiService } from '@b2b/common/services/api/types';
import { IInjectable, StateParams } from '@uirouter/angularjs';

export function EventTemplatesDataResolver(props: { noCache?: boolean } = {}): IInjectable {
  return [
    '$stateParams',
    'ApiService',
    function ($stateParams: StateParams, ApiService: ApiService) {
      return ApiService.program.get($stateParams.id, props.noCache);
    },
  ];
}
